import useCartWidget from 'hooks/cart-widget'
import { CHECKOUT } from 'routes/paths'
import { Button, Link } from '~ui'
import { getImageUrl } from '~utils'
import CartWidget from './cart-widget'

type CartWidgetContainerProps = {
  children?: (v: { cartLoading: boolean; isCart: boolean }) => void
}

const CartWidgetContainer: React.FC<CartWidgetContainerProps> = ({ children }) => {
  const {
    cart: { artwork, isCart, quantity, price, cartLoading, isPackage },
    cancelCart,
    cancelCartLoading,
  } = useCartWidget()

  return (
    <>
      {(isCart || cancelCartLoading) && (
        <CartWidget
          artistFullName={artwork?.artistFullName}
          cartItemImage={getImageUrl(artwork?.artworkOrTourOrArtistImage, 100, 100)}
          eventDate={artwork?.eventStartDateLocal}
          isPackage={isPackage}
          quantity={quantity}
          price={price}
          loading={cartLoading || cancelCartLoading}
          actions={[
            <Link color="green" href={CHECKOUT}>
              Go to cart
            </Link>,
            <Button danger variant="secondary" onClick={cancelCart}>
              Clear cart
            </Button>,
          ]}
        />
      )}
      {children &&
        children({
          cartLoading,
          isCart,
        })}
    </>
  )
}

export default CartWidgetContainer
